// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".input-group-chef-review{margin-bottom:.5rem}.input-group-chef-review input,.input-group-chef-review textarea{border-radius:.125rem;border-width:1px;display:block;width:100%;--tw-border-opacity:1;border-color:#707070;border-color:rgba(112,112,112,var(--tw-border-opacity,1));padding:.25rem .5rem}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
